import script from "./OwnerContactCreate.vue?vue&type=script&setup=true&lang=js"
export * from "./OwnerContactCreate.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__